/**
 * Flattens the preview workout items into:
 *  - `flat`: the navigable list of exercise objects (session-break sub-items hoisted
 *    into the same index space, breaks themselves excluded), used by the detail view.
 *  - `rendered`: the ordered render list for the sidebar, where each entry is either
 *    a `break` section header or an `exercise` carrying its index into `flat`.
 *
 * Mirrors the index semantics of the workouts module's `workoutsMapper`
 * (WorkoutsList.js) so clicking an item opens the matching detail card.
 */
const flattenPreviewWorkouts = (items = []) => {
  const flat = [];
  const rendered = [];

  items.forEach((item) => {
    if (item.type === 'BR') {
      rendered.push({ kind: 'break', item });
      (item.sessionBreakItems || []).forEach((subItem) => {
        rendered.push({ kind: 'exercise', item: subItem, flatIndex: flat.length });
        flat.push(subItem);
      });
    } else {
      rendered.push({ kind: 'exercise', item, flatIndex: flat.length });
      flat.push(item);
    }
  });

  return { flat, rendered };
};

export default flattenPreviewWorkouts;
